import React from 'react'
import { Account as AfgAccount } from '@ally/data-types-afg-accounts'
import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'
import { asCurrency } from '@ally/aos-utils'
import MobileCardDetail from './MobileCardDetail'
import { AFGAccountDetailsLink } from '../AccountDetailsLink'
import { isAutoAccountWithNoActiveVehicle } from '../../Vehicles/utils'

const StyledAccountDetailsLink = styled(AFGAccountDetailsLink)`
  width: 100%;
  justify-content: flex-start;
`

const TotalAvailableBalance: React.FC<{
  accounts: AfgAccount[]
}> = ({ accounts }) => {
  const accountsWithActiveVehicle = accounts.filter(
    account => !isAutoAccountWithNoActiveVehicle(account),
  )
  const total = accountsWithActiveVehicle.reduce(
    (sum: number, account: AfgAccount) =>
      (account.meta?.nextPayment?.totalAmountDue ?? 0) + sum,
    0,
  )

  const totalAmount =
    accountsWithActiveVehicle.length > 0 ? asCurrency(total) : 'Unavailable'

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderLeftStyle="solid"
      borderLeftWidth="7px"
      py="sm"
      px="xs"
      borderTop="1px solid"
      borderTopColor="slate-2"
      width="100%"
      borderBottom="1px solid"
      borderBottomColor="slate-2"
    >
      <Box fontWeight="bold" style={{ textTransform: 'uppercase' }}>
        Total
      </Box>
      <Box fontWeight="bold">{totalAmount}</Box>
    </Box>
  )
}

const MobileVehicleAccountList: React.FC<{
  accounts: AfgAccount[]
}> = ({ accounts }) => {
  return (
    <>
      {accounts.map((account: AfgAccount) => {
        const key = `detail-${account.id}`
        const content = <MobileCardDetail account={account} />

        return (
          <StyledAccountDetailsLink
            account={account}
            text={content}
            key={key}
          />
        )
      })}
      <TotalAvailableBalance accounts={accounts} />
    </>
  )
}

export default MobileVehicleAccountList
